module.exports = __webpack_public_path__ + "static/accestoWidePool-5de7634b6c5691f98e05aab482827d81.svg";